import React from "react";
import { LayoutDashboard, FileText, Users, Package, MapPin, BarChart3, ChevronDown, ChevronRight, Home, Truck, Boxes, Layers, Tag, X, } from "lucide-react";
import { NavLink } from "react-router-dom";
export default function Sidebar({ mobileOpen, setMobileOpen }) {
    const [masterOpen, setMasterOpen] = React.useState(true);
    const closeMobile = () => {
        if (window.innerWidth <= 768) {
            setMobileOpen(false);
        }
    };
    return (
        <>
            {mobileOpen && (
                <div className="sidebar-overlay" onClick={() => setMobileOpen(false)} />
            )}
            <aside className={`backoffice-sidebar ${mobileOpen ? "mobile-open" : ""}`}>
                <div className="sidebar-logo">
                    <div className="sidebar-logo-icon">NP</div>
                    <div className="sidebar-logo-text">
                        <strong>Natural Packers</strong>
                        <span>& Movers</span>
                    </div>
                    <button className="sidebar-close" onClick={() => setMobileOpen(false)}><X size={20} /></button>
                </div>
                <div className="sidebar-menu">
                    <div className="sidebar-section-title">MAIN MENU</div>
                    <NavLink to="/backoffice/dashboard" onClick={closeMobile} className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}>
                        <LayoutDashboard size={19} />
                        <span>Dashboard</span>
                    </NavLink>
                    <NavLink to="/backoffice/quotes" onClick={closeMobile} className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}>
                        <FileText size={19} />
                        <span>Quotes</span>
                    </NavLink>
                    <NavLink to="/backoffice/customers" onClick={closeMobile} className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}>
                        <Users size={19} />
                        <span>Customers</span>
                    </NavLink>
                    <NavLink to="/backoffice/services" onClick={closeMobile} className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}>
                        <Package size={19} />
                        <span>Services</span>
                    </NavLink>
                    <NavLink to="/backoffice/locations" onClick={closeMobile} className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}>
                        <MapPin size={19} />
                        <span>Locations</span>
                    </NavLink>
                    <div className="sidebar-section-title master-title">MASTER DATA</div>
                    <button type="button" className={`sidebar-link master-toggle ${masterOpen ? "open" : ""}`} onClick={() => setMasterOpen(!masterOpen)}>
                        <Layers size={19} />
                        <span>Master Data</span>
                        {masterOpen ? (
                            <ChevronDown size={16} className="menu-arrow" />) : (
                            <ChevronRight size={16} className="menu-arrow" />)}
                    </button>
                    {masterOpen && (
                        <div className="submenu">
                            <NavLink to="/backoffice/masters/house-types" onClick={closeMobile} className={({ isActive }) => isActive ? "submenu-link active" : "submenu-link"}>
                                <Home size={15} />House Types</NavLink>
                            <NavLink to="/backoffice/masters/moving-types" onClick={closeMobile} className={({ isActive }) => isActive ? "submenu-link active" : "submenu-link"}>
                                <Truck size={15} />Moving Types</NavLink>
                            <NavLink to="/backoffice/masters/load-types" onClick={closeMobile} className={({ isActive }) => isActive ? "submenu-link active" : "submenu-link"}>
                                <Truck size={15} />Load Types</NavLink>
                            <NavLink to="/backoffice/masters/service-categories" onClick={closeMobile} className={({ isActive }) => isActive ? "submenu-link active" : "submenu-link"}>
                                <Boxes size={15} />Service Categories</NavLink>
                            <NavLink to="/backoffice/masters/additional-services" onClick={closeMobile} className={({ isActive }) => isActive ? "submenu-link active" : "submenu-link"}>
                                <Package size={15} />Additional Services</NavLink>
                            <NavLink to="/backoffice/masters/package-types" onClick={closeMobile} className={({ isActive }) => isActive ? "submenu-link active" : "submenu-link"}>
                                <Tag size={15} />Package Types</NavLink>
                            <NavLink to="/backoffice/masters/quote-status" onClick={closeMobile} className={({ isActive }) => isActive ? "submenu-link active" : "submenu-link"}>
                                <FileText size={15} />Quote Status</NavLink>
                        </div>
                    )}
                    <div className="sidebar-section-title">ANALYTICS</div>
                    <NavLink to="/backoffice/reports" onClick={closeMobile} className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}>
                        <BarChart3 size={19} /><span>Reports</span></NavLink>
                </div>
                <div className="sidebar-bottom">
                    <div className="sidebar-company">
                        <div className="company-mini-logo">NP</div>
                        <div>
                            <strong>Backoffice</strong>
                            <span>Natural Packers & Movers</span>
                        </div>
                    </div>
                </div>
            </aside>
        </>
    );
}